module.exports = __webpack_public_path__ + "img/lehrer.aac5d6dc.png";